import * as React from 'react';
import DatePicker from './DatePickerComponent';

const TimePicker = React.forwardRef((props, ref) => (
  <DatePicker.RangePicker {...props} picker="time" mode={undefined} ref={ref}/>
));

TimePicker.displayName = 'TimePicker';

export default TimePicker;